import { API } from "@swivl-mono/api-helper";
import { DateTime } from "luxon";
import React, { useEffect } from "react";

import { BotAnalyticsDashboard } from "../../Components/BotAnalyticsDashboard/BotAnalyticsDashboard";
import { DateRangeSelect } from "../../Components/BotAnalyticsDashboard/DateRangeSelect/DateRangeSelect";
import { Member } from "../../Models/Member/Member.Current";
import { NavBar } from "../../Models/NavBar/NavBar.Model";
import { useSwivlNavigate } from "../../Models/NavBar/useSwivlNavigate";
import "./DashboardView.scss";
import { EscalationAnalyticsDashboard } from "./EscalationAnalyticsDashboard/EscalationAnalyticsDashboard";

function GetAnalyticDateRange() {
  var startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  const now = new Date();
  let endDate = now;

  if (localStorage.analyticsDateRange) {
    const split = localStorage.analyticsDateRange.split("__");
    if (split.length >= 3) {
      const timestamp = parseInt(split[0]);
      if (now.getTime() - timestamp < 1000 * 60 * 60) {
        startDate = new Date(parseInt(split[1]));
        endDate = new Date(parseInt(split[2]));
        return { startDate: startDate, endDate: endDate };
      }
    }
  }
  return { startDate: startDate, endDate: endDate };
}
function SetAnalyticDateRange(startDate, endDate) {
  localStorage.setItem("analyticsDateRange", Date.now() + "__" + startDate.getTime() + "__" + endDate.getTime());
}

export default function DashboardView() {
  const initialDateRange = GetAnalyticDateRange();
  const [startDate, setStartDate] = React.useState<string>(DateTime.fromJSDate(initialDateRange.startDate || Date.now()).toISODate() || "2021-01-01");
  const [endDate, setEndDate] = React.useState<string>(DateTime.fromJSDate(initialDateRange.endDate).toISODate() || "2021-01-01");
  const navigate = useSwivlNavigate();
  const datePicked = (isStart: boolean, date: Date) => {
    if (isStart) {
      SetAnalyticDateRange(date, new Date(endDate));
      setStartDate(DateTime.fromJSDate(date).toISODate()!);
    } else {
      SetAnalyticDateRange(new Date(startDate), date);
      setEndDate(DateTime.fromJSDate(date).toISODate()!);
    }
  };

  useEffect(() => {
    API.Tables.queryTable(Member.orgId, "gatecode-00", startDate, endDate, {}).then((data) => {
      //do something
    });

    NavBar.set(
      <DateRangeSelect startDate={DateTime.fromISO(startDate).toJSDate()} endDate={DateTime.fromISO(endDate).toJSDate()} datePicked={datePicked} />,
      <NavBar.Component.Logo />,
      null,
      "Dashboard",
    );
  }, [startDate, endDate]);

  return (
    <div className="DashboardView Page">
      <header>
        <div className="welcomeMsg">{Member.account && Member.account.firstName ? "👋 Welcome, " + Member.account.firstName : "👋 Welcome"}</div>
        <div className="edu">
          Visit our{" "}
          <a href="https://learn.tryswivl.com" target="_blank" rel="noreferrer">
            Educational Resource Library 📖
          </a>
        </div>
      </header>

      <BotAnalyticsDashboard
        orgId={Member.orgId}
        startDay={startDate}
        endDay={endDate}
        viewAllQuestsClicked={() => {
          navigate(`/analytics/quests/${startDate}/${endDate}`);
        }}
        viewAllIntentsClicked={() => {
          navigate(`/analytics/intents/${startDate}/${endDate}`);
        }}
      />
      {/* <EscalationAnalyticsDashboard 
                  viewAllClicked={() => {
                    navigate(`/analytics/agents/${startDate}/${endDate}`)  
                }}  
                orgId={Member.orgId}    
                  startDay={startDate}
                    endDay={endDate}/>       */}
    </div>
  );

  // }
}
